var I=["Critical","Important","Normal"],a={Critical:"Критичні",Important:"Важливі",Normal:"Звичайні"};export{a as NOTIFICATION_SEVERITY_GROUP_LABELS,I as NOTIFICATION_SEVERITY_ORDER};
//# sourceMappingURL=notificationSeverities.js.map